import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import Button from "@mui/material/Button";
import Alert from "@mui/material/Alert";
import { FirebaseApp, db, auth } from "./firebase";
import { collection, getDocs, addDoc, deleteDoc } from "firebase/firestore";
import { sendSignInLinkToEmail } from "firebase/auth";
import { onLog } from "firebase/app";

function App() {
  const depart = [
    "Electrical Engineering",
    "Civil Engineering",
    "Electronics and Communication Engineering",
    "Computer Science Engineering",
    "Mechanical Engineering",
  ];
  const [clicked, setclicked] = useState(false);
  const [dep, setdep] = useState("Your Department");
  const [seluser, setseluser] = useState("Your name");

  const [u1, setu1] = useState([{ Name: "Select department first" }]);

  function uclick(nm) {
    setseluser(nm);
  }

  function hclick(branch) {
    setdep(branch);

    const x = [];
    const colref = collection(db, "Users");
    getDocs(colref).then((response) => {
      response.docs.map((item) => {
        const a = { ...item.data(), id: item.id };

        if (a.Department === branch) x.push(a);
      });

      setu1(x);
    });
  }

  const navigate = useNavigate();
  function handleadminlogin() {
    navigate("/adminlogin");
  }

  const sendMail = async (email, username, userid) => {
    const actionCodeSettings = {
      // URL you want to redirect back to. The domain (www.example.com) for this
      // URL must be in the authorized domains list in the Firebase Console.

      url: "https://helpful-tarsier-47747e.netlify.app/userpage",

      // This must be true.
      handleCodeInApp: true,
      // iOS: {
      //   bundleId: 'com.example.ios'
      // },
      // android: {
      //   packageName: 'com.example.android',
      //   installApp: true,
      //   minimumVersion: '12'
      // },
      // dynamicLinkDomain: 'example.page.link'
    };
    sendSignInLinkToEmail(auth, email, actionCodeSettings)
      .then(() => {
        // The link was successfully sent. Inform the user.
        // Save the email locally so you don't need to ask the user for it again
        // if they open the link on the same device.

        window.localStorage.setItem("emailForSignIn", email);
        window.localStorage.setItem("nameForSignIn", username);
        window.localStorage.setItem("idForSignIn", userid);

        setclicked(true);

        // ...
      })
      .catch((error) => {
        const errorCode = error.code;
        const errorMessage = error.message;
        console.log(error);
        // ...
      });
  };
  async function handleclick(event) {
    event.preventDefault();

    const b = u1.filter(function (item) {
      return item.Name === seluser;
    });
    const mail = b[0].Email;
    const username = b[0].Name;
    const userid = b[0].id;

    await sendMail(mail, username, userid);
  }

  return (
    <div className="container mt-1">
      <div style={{ backgroundColor: "#343a40" }}>
        <nav class="navbar navbar-expand-lg navbar-dark">
          <a class="navbar-brand" href="http://nitp.ac.in/">
            <img
              src="https://nitp.ac.in/static/logo512-579d034908ae89b5e0243d1274937d5d.png"
              alt=""
              width="30"
              height="24"
              margin-right="100"
              class="d-inline-block align-text-top"
            />
            Nit Patna complaint portal
          </a>
          <button
            class="navbar-toggler"
            type="button"
            data-toggle="collapse"
            data-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span class="navbar-toggler-icon"></span>
          </button>
          <div class="collapse navbar-collapse" id="navbarSupportedContent">
            <ul class="navbar-nav ml-auto">
              <li class="nav-item">
                <button
                  className="btn btn-outline-success"
                  onClick={handleadminlogin}
                >
                  Admin Login
                </button>
              </li>
            </ul>
          </div>
        </nav>
      </div>

      <div class="container mt-4">
        <label for="exampleFormControlInput1" class="form-label">
          Department
        </label>
        <div class="input-group mb-3">
          <input
            type="text"
            class="form-control"
            aria-label="Text input with dropdown button"
            value={dep}
          />
          <button
            class="btn btn-outline-secondary dropdown-toggle"
            type="button"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          ></button>
          <ul class="dropdown-menu dropdown-menu-end">
            {depart.map((branch) => (
              <li>
                <a
                  class="dropdown-item"
                  href="#"
                  value={branch}
                  onClick={() => hclick(branch)}
                >
                  {branch}
                </a>
              </li>
            ))}
          </ul>
        </div>
        <label for="exampleFormControlInput1" class="form-label">
          Name
        </label>
        <div class="input-group mb-3">
          <input
            type="text"
            class="form-control"
            aria-label="Text input with dropdown button"
            value={seluser}
          />
          <button
            class="btn btn-outline-secondary dropdown-toggle"
            type="button"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          ></button>
          <ul class="dropdown-menu dropdown-menu-end">
            {u1.map((i) => (
              <li>
                <a
                  class="dropdown-item"
                  href="#"
                  value={i.Name}
                  onClick={() => uclick(i.Name)}
                >
                  {i.Name}
                </a>
              </li>
            ))}
          </ul>
        </div>

        <button
          type="button"
          class="btn btn-dark"
          disabled={dep === "Your Department" || seluser === "Your name"}
          onClick={handleclick}
        >
          Verify
        </button>
      </div>
      <div style={{ visibility: clicked ? "visible" : "hidden" }}>
        <Alert onClose={() => setclicked(false)}>Mail sent successfully!</Alert>
      </div>
    </div>
  );
}

export default App;
